import styles from "./../StudentPage.module.css";
export default function StepConfirmation({ price, printedCopy, onOk }) {
    const total = price + (printedCopy ? 20 : 0);

    return (
        <div className={`${styles.formStep} ${styles.formCard}`}>
            <h3 className={styles.formTitle}>Confirmation</h3>

            <p className={styles.confirmText}>Your request has been accepted.</p>

            <p className={styles.totalText}>
                The service fee is{" "}
                <span className={styles.price}>${total}</span>.
            </p>

            {printedCopy && (
                <p className={styles.confirmText}>
                    (Including $20 for a printed copy)
                </p>
            )}

            <p className={styles.confirmText}>
                You need to pay this invoice at Office 321 of the Main Building of the
                International Higher School of Medicine (Intergelpo 1F),
            </p>
            <p className={styles.confirmText}>
                from Monday to Friday, 10:00–15:00.
            </p>
            <p className={styles.confirmText}>
                <strong>PAYMENT IS ACCEPTED IN CASH ONLY.</strong>
            </p>

            <p className={styles.confirmText}>Have a nice day.</p>

            <div className={styles.confirmActions}>
                <button className={styles.confirmButton} onClick={onOk}>
                    OK
                </button>
            </div>
        </div>
    );
}
